import { Component, inject, signal } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { Notificacion } from 'src/app/models/Notificacion';
import { NotificacionService } from 'src/app/services/notificacion.service';
import { AuthService } from 'src/app/services/auth.service';
import { LoadingService } from 'src/app/services/loading.service';
import { API_URI } from 'src/environments/environment';

@Component({
    selector: 'app-notification-detail',
    templateUrl: './notification-detail.component.html',
    styleUrls: ['./notification-detail.component.css'],
    standalone: false
})
export class NotificationDetailComponent {
  private _aRoute = inject(ActivatedRoute);
  private _router = inject(Router);
  private _location = inject(Location);
  private _authService = inject(AuthService);
  private _notificacionService = inject(NotificacionService);
  private _loadingService = inject(LoadingService);

  error = signal<string>('');
  loading = signal<boolean>(true);
  notificacion = signal<Notificacion | null>(null);

  id = Number(this._aRoute.snapshot.paramMap.get('id') ?? 0);

  async ngOnInit(): Promise<void> {
    document.documentElement.scrollTop = 0;

    await this._loadingService.run(async () => {
      try {
        await this._authService.ensureSession();
      } catch (e: any) {
        console.error(e);
        this._router.navigate(['/sign-in']);
        return;
      }

      try {
        const res = await firstValueFrom(this._notificacionService.getNotificacion(this.id));

        if (!res) {
          this.error.set('La notificación no existe.');
          this._router.navigate(['/notifications']);
          return;
        }

        this.notificacion.set(res);

        // Recién acá (al entrar efectivamente al detalle) se marca como leída.
        if (!res.b_visto) {
          res.b_visto = true;
          try {
            await firstValueFrom(this._notificacionService.updateNotificacion(res));
          } catch (e) {
            console.error('Error al marcar como leída la notificación:', e);
          }
        }
      } catch (e) {
        console.error(e);
        this.error.set('Error al obtener la notificación.');
      } finally {
        this.loading.set(false);
      }
    });
  }

  getImgUrl(x_img?: string | null): string {
    return x_img ? `${API_URI}uploads/images/${x_img}` : '';
  }

  back(): void {
    this._location.back();
  }
}
